export default "__VITE_ASSET__aJI93g5m__"